import type { PropsWithChildren } from "react";
import { FormProvider } from "react-hook-form";

import { PaywallCheckoutContextProvider } from "@/react/contexts/Paywalls/paywallCheckoutContext";

import { CheckoutErrorBoundary } from "../CheckoutErrorBoundary";
import { PaywallCustomization } from "../CheckoutPage/CheckoutDescription/PaywallCustomization";
import { PricePreviewContext } from "../CheckoutPage/CheckoutForm/PricePreview/PricePreviewProvider";
import { useCheckoutFormMethods } from "../hooks/useCheckoutFormMethods";
import type { CheckoutProps } from "../types/CheckoutProps";

export const FormWrapper = ({
  children,
  ...checkoutProps
}: PropsWithChildren<CheckoutProps>) => {
  const formMethods = useCheckoutFormMethods(checkoutProps);

  return (
    <CheckoutErrorBoundary checkoutProps={checkoutProps}>
      <FormProvider {...formMethods}>
        <PaywallCheckoutContextProvider {...checkoutProps}>
          <PricePreviewContext>
            <PaywallCustomization.Provider
              paywallCustomization={
                checkoutProps?.paywall?.paywall_customization
              }
              checkoutPreviewContext={checkoutProps?.checkoutPreviewContext}
            >
              {children}
            </PaywallCustomization.Provider>
          </PricePreviewContext>
        </PaywallCheckoutContextProvider>
      </FormProvider>
    </CheckoutErrorBoundary>
  );
};
